import Vue from 'vue'

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css'; // 引入Element UI样式

import 'normalize.css/normalize.css'
import '@/styles/index.less'
import App from './App.vue'
import store from './store'
import router from './router'

import './permission'

Vue.config.productionTip = false

Vue.use(ElementUI);

new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})
